export const mobileApplicationSettingsFromDto = (settings) => ({
    iosEnabled: settings && settings.iosEnabled || false,
    iosBundleId: settings && settings.iosBundleId || '',
    iosSuffix: settings && settings.iosSuffix || '',
    androidEnabled: settings && settings.androidEnabled || false,
    androidNamespace: settings && settings.androidNamespace || '',
    androidHashkey: settings && settings.androidHashkey || '',
});

export const mobileApplicationSettingsToDto = (settings) => ({
    iosEnabled: settings.iosEnabled || undefined,
    iosBundleId: settings.iosEnabled && settings.iosBundleId || undefined,
    iosSuffix: settings.iosEnabled && settings.iosSuffix || undefined,
    androidEnabled: settings.androidEnabled || undefined,
    androidNamespace: settings.androidEnabled && settings.androidNamespace || undefined,
    androidHashkey: settings.androidEnabled && settings.androidHashkey || undefined,
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/mobile-app-support/mobile-app-support.functions.js